import { PreloadLink } from '@farmersdog/tosa/src/components/shared/PreloadLink';

import { useHomepageHeroExperiment } from 'src/hooks/useHomepageHeroExperiment';
import { useShowHomepageRedesign } from 'src/hooks/useHomepageRedesign';
import { generateSourcesForPreloader } from 'src/pages/Home/components/AssetPreloader/assets/shared';

import { getSourcesForHomepageHero } from './getSourcesForHomepage';

import { getPreloadLinksForBenefitCards } from './utils/getPreloadLinksForBenefitCards';

export const AssetPreloader = () => {
  const { treatment: homepageRedesignTreatment } = useShowHomepageRedesign();
  const { treatment: homepageHeroTreatment } = useHomepageHeroExperiment();

  // Hero assets
  const { desktopSources, mobileSources } = getSourcesForHomepageHero({
    homepageHeroTreatment,
    homepageRedesignTreatment,
  });
  const heroAssets = generateSourcesForPreloader({
    mobileSources,
    desktopSources,
  });

  // Benefit card assets - only for OLS treatment on desktop
  const benefitCardAssets = getPreloadLinksForBenefitCards(
    homepageRedesignTreatment
  );

  // Combine all assets into a single array
  const allAssets = [...heroAssets, ...benefitCardAssets];

  return <PreloadLink items={allAssets} />;
};
